<script>
    const domain = 'https://api.sosbackend.com';
    const domainChat = 'https://socket.sosbackend.com';

    //const domain = 'http://localhost:3000';
    // const domainChat = 'http://localhost:5003';

    export default {
        domain: domain,
        domainChat: domainChat,
        addresses: {
            address: `${domain}/api/address/v1/`,
            geolocation: `${domain}/api/address/geo/v1/`,
            getCurrentGeolocation: `${domain}/api/users/geolocation/search/v1/`,
            nationalities: `${domain}/api/address/nationalities/v1/`,
        },
        systemUsers: {
            changeEmail: `${domain}/api/users/system/change/email/v1/`, 
            reject: `${domain}/api/users/system/status/reject/v1/`,
            delete: `${domain}/api/users/delete/v1/`,
            systemUser: `${domain}/api/users/v1/`,
            systemUserFormdata: `${domain}/api/users/formdata/v1/`,
            login: `${domain}/api/users/system/login/v1/`,
            gencode: `${domain}/api/users/system/password/gencode/v1/`,
            checkCode: `${domain}/api/users/system/password/checkcode/v1/`,
            resetPass: `${domain}/api/users/system/password/change/online/v1/`,
            resetPassNotLog: `${domain}/api/users/system/password/change/v1/`,
            getMe: `${domain}/api/users/me/v1/`,
            ListUserByType: `${domain}/api/users/bytype/v1/`,
            filter:  `${domain}/api/users/system/search/customeruser/v1/`,
            companyUser: `${domain}/api/users/system/search/companyuser/v1/`,
            updateTerms: `${domain}/api/users/system/update/v1/`,
            count: `${domain}/api/generic/count/byfilter/v1/`,
            customerUser: `${domain}/api/users/system/search/customeruser/v1/`,
            approveDocument:  `${domain}/api/users/system/status/aprove/v1/`,
            approveByFleetDriver:  `${domain}/api/users/system/status/aprove/by/fleetdriver/v1`,
            geolocation: `${domain}/api/users/geolocation/search/v1/`,
            popularVehicles: `${domain}/api/users/truck/list/group/by/manufacturer/v1/`,
            checkPhone: `${domain}/api/users/system/checkphone/v1/`,
            indicationUse: `${domain}/api/users/indications/uses/filter/v1/`,
            customersWaitingForApproval: `${domain}/api/users/list/customer/waiting-for-approval/v1/`,
        },
        healths: {
            health: `${domain}/api/users/healths/v1/`,
            filter: `${domain}/api/users/healths/filter/v1/`,
        },
        bankSlips:{
            getByCompany: `${domain}/api/orders/bankslips/filter/v1/`,
            generateBankSlip: `${domain}/api/orders/generate/bankslips/v1/`,
            generateBankSlipAdmin: `${domain}/api/orders/generate/bankslips/admin/v1/`,
        },
        banners:{
            banner: `${domain}/api/banners/formdata/v1/`,
            list: `${domain}/api/banners/v1/`,
            delete: `${domain}/api/banners/delete/v1/`,
        },
        orders: {
            listOrdersByStatus: `${domain}/api/orders/list/bystatus/v1/`,
            registerPrice: `${domain}/api/orders/register/price/v1/`,
            order: `${domain}/api/orders/v1/`,
            payOrder: `${domain}/api/orders/payment/v1/`,
            listByUser: `${domain}/api/orders/list/byuser/v1/`,
            updateInfos:`${domain}/api/orders/update/infos/v1/`,
            close:`${domain}/api/orders/close/v1/`,
            closeholder:`${domain}/api/orders/holder/close/v1/`,
            search:`${domain}/api/orders/list/bystatus/v1/`,
            reject:`${domain}/api/orders/reject/v1/`,
            holder: {
                listOrdersByStatus: `${domain}/api/orders/holder/list/bystatus/v1/`,
                listOrdersByStatusCompany: `${domain}/api/orders/holder/company/list/bystatus/v1/`,
                addCompany:`${domain}/api/orders/holder/add/company/v1/`, 
                listAll: `${domain}/api/orders/holder/v1/`,
                listOrderByDate: `${domain}/api/orders/holder/list/group/by/date/v1/`,
                listManufacture: `${domain}/api/orders/holder/list/group/by/manufacturer/v1/`,
                listFamilies: `${domain}/api/orders/holder/list/group/by/family/v1/`,
                listServices: `${domain}/api/orders/holder/list/group/by/service/v1/`,
                listCertifies: `${domain}/api/orders/holder/list/group/by/certifie/v1/`,
            }
        },
        trucks: {
            truck: `${domain}/api/users/truck/v1/`,
            truckFormData: `${domain}/api/users/truck/formdata/v1/`,
            listAll: `${domain}/api/users/truck/v1/`,
            listByType: `${domain}/api/users/truck/search/v1/`,
            changeTruckDriver: `${domain}/api/users/truck/change/truckdriver/v1/`,
            filterByFleetDriver: `${domain}/api/users/truck/fleet/driver/search/v1/`,
        },
        companies: {
            company: `${domain}/api/company/v1/`,
            listActivies: `${domain}/api/company/list/v1/`,
            listByType: `${domain}/api/company/list/bytype/v1/`,
            perfil: `${domain}/api/company/perfil/v1/`,
            perfilParts: `${domain}/api/company/perfil/parts/v1/`,
            workhours: {
                post: `${domain}/api/company/workhours/v1/`,
                getByCompany: `${domain}/api/company/workhours/bycompany/v1/`
            },
            companyUser:  `${domain}/api/users/system/search/companyuser/v1/`,
            filter: `${domain}/api/company/filter/v1/`,
        },
        curriculums:{
            curriculum: `${domain}/api/users/curriculums/v1/`,
            search: `${domain}/api/users/curriculums/search/v1/`,
        },
        cep: {
            find: `https://viacep.com.br/ws/`,
        },
        parts: {
            groups:{
                group: `${domain}/api/products/parts/groups/v1/`,
            },
            families:{
                family: `${domain}/api/products/parts/families/v1/`,
                listByType: `${domain}/api/products/parts/families/list/bytype/v1/`,
            },
            brands:{
                brand: `${domain}/api/products/parts/brands/v1/`,
            },
            parts:{
                part: `${domain}/api/products/parts/v1/`,
            },
            manufacturer:{
                listByType: `${domain}/api/users/truck/manufacturer/list/bytype/v1/`,
            },
            category:{
                listByType: `${domain}/api/users/truck/category/list/bytype/v1/`,
            },
            model:{
                listByType: `${domain}/api/users/truck/model/list/bytype/v1/`,
            },
            certifies:{
                list: `${domain}/api/products/certifies/list/v1/`,
                get: `${domain}/api/products/certifies/v1/`,
                
            }
        },

        models:{
            listByManufacturer: `${domain}/api/users/truck/model/list/bymanufacturer/v1/`,
        },

        helpers:{
            listTruckTrailer: `${domain}/api/helpers/data/trucktrailer/types/v1/`,
            listTruck: `${domain}/api/helpers/data/truck/types/v1/`,
            listTruckGroup: `${domain}/api/helpers/data/truck/grouptypes/v1/`,
            listTraction: `${domain}/api/helpers/data/truck/tractions/v1/`,
            listCnhTypes: `${domain}/api/helpers/data/cnh/categories/v1/`,
            listSpeciesTypes: `${domain}/api/helpers/data/trucktrailer/species/types/v1/`,
            
        },
        alerts:{
            filter: `${domain}/api/users/alerts/search/v1/`,
            closeAlert: `${domain}/api/users/alerts/close/v1/`,
            list: `${domain}api/users/alerts/v1/`,
        },
        chat:{
            conversations: `${domain}/api/chat/list/conversations/v1/`,
            filter: `${domain}/api/chat/filter/v1/`,
        },
        cards:{
            card: `${domain}/api/users/cards/v1/`,
            getMain: `${domain}/api/users/cards/getmain/byuser/v1/`,
            getMainByCompany: `${domain}/api/users/cards/getmain/bycompany/v1/`,
        },
        location:{
            geolocation: `https://maps.googleapis.com/maps/api/geocode/json?latlng=`,
        },
        manufacturer:{
            create: `${domain}/api/users/truck/manufacturer/v1/`,
        },
        model:{
            create: `${domain}/api/users/truck/model/v1/`,
        },
        reports:{
            trucker: {
                withoutVehicle: `${domain}/api/users/list/customer/without/truck/v1/`,
            }, 
            truck: {
                withoutCertifie: `${domain}/api/users/truck/list/without/certifies/v1/`,
                expiredCertifie: `${domain}/api/users/truck/list/expired/certifies/v1/`
            }
        },
        notifications: {
            send: `${domain}/api/users/notifications/send/v1/`,
        },
        sinesp: {
            search: `${domain}/api/users/truck/search/sinesp/plate/v1/`,
        }
}
</script>

